import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import "./SharedSidebar.scss";

function SharedSidebar({ title, items, activeKey, onSelect }) {
  const [isOpen, setIsOpen] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState({});

  useEffect(() => {
    const nextState = { ...expandedGroups };

    items.forEach((item) => {
      if (!item.children?.length) return;

      const shouldExpand = item.children.some((child) => child.key === activeKey) || activeKey === item.key;
      nextState[item.key] = shouldExpand && item.key === "pricing" ? true : false;
    });

    setExpandedGroups(nextState);
  }, [activeKey, items]);

  const handleSelect = (key) => {
    onSelect(key);
    setIsOpen(false);
  };

  const toggleGroup = (item) => {
    const isCurrentlyExpanded = Boolean(expandedGroups[item.key]);
    setExpandedGroups((prev) => ({
      ...prev,
      [item.key]: !isCurrentlyExpanded,
    }));
  };

  return (
    <>
      <button
        className="panel-sidebar__toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        {isOpen ? <X size={20} /> : <Menu size={20} />}
        <span>Menu</span>
      </button>

      <aside className={`panel-sidebar ${isOpen ? "panel-sidebar--open" : ""}`}>
        <nav className="panel-sidebar__nav">
          <span className="panel-sidebar__nav-title">{title}</span>
          {items.map((item) => {
            const { key, label, icon: Icon, children } = item;
            const isGroupActive = children?.some((child) => child.key === activeKey) || activeKey === key;

            if (children?.length) {
              const isExpanded = Boolean(expandedGroups[key]);

              return (
                <div key={key} className="panel-sidebar__group">
                  <button
                    className={`panel-sidebar__nav-item ${isGroupActive ? "panel-sidebar__nav-item--active" : ""}`}
                    onClick={() => toggleGroup(item)}
                  >
                    <Icon size={18} />
                    <span>{label}</span>
                    <span className={`panel-sidebar__chevron ${isExpanded ? "panel-sidebar__chevron--open" : ""}`} aria-hidden="true">
                      ▾
                    </span>
                  </button>

                  {isExpanded && (
                    <div className="panel-sidebar__subnav">
                      {children.map((child) => {
                        const ChildIcon = child.icon;
                        return (
                          <button
                            key={child.key}
                            className={`panel-sidebar__subnav-item ${activeKey === child.key ? "panel-sidebar__subnav-item--active" : ""}`}
                            onClick={() => handleSelect(child.key)}
                          >
                            <ChildIcon size={15} />
                            <span>{child.label}</span>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <button
                key={key}
                className={`panel-sidebar__nav-item ${activeKey === key ? "panel-sidebar__nav-item--active" : ""}`}
                onClick={() => handleSelect(key)}
              >
                <Icon size={18} />
                <span>{label}</span>
              </button>
            );
          })}
        </nav>
      </aside>

      <div
        className={`panel-sidebar__overlay ${isOpen ? "panel-sidebar__overlay--visible" : ""}`}
        onClick={() => setIsOpen(false)}
      />
    </>
  );
}

export default SharedSidebar;
